<div class="scroller-card">
  <slot />
</div>

<style lang="scss">
  .scroller-card {
    background: rgba(#000, 0.7);
    color: #fff;
    font-size: 24px;
    padding: 1em;
    text-align: center;
  }
</style>
